/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const SubmoduleLink = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const ArrowIndicator = styled.span({
  display: 'flex',
  alignItems: 'center',
});
